<template>
  <div
    class="event-card"
    v-match-heights="{
      el: ['.event-head', '.event-body'],
      disabled: [575]
    }"
  >
    <div class="event-head">
      <div class="event-type">{{ event.eventType }}</div>
      <div class="date-time">
        <div class="date">{{ getDate(event.date) }}</div>
        <div class="time">{{ event.time }}</div>
      </div>
    </div>
    <div class="event-body">
      <div class="event-info">
        <div class="event-title">{{ event.title }}</div>
        <div class="views-count" v-if="event.clubId._id === localClubId">
          <span v-if="event.views !== 0">{{ event.views }}</span>
          <span v-else class="no-views">No</span>
          views
        </div>
        <div
          class="event-description"
          v-if="event.eventType === 'Game Schedule'"
        >
          <div class="team">{{ event.teamA }}</div>
          <div class="vs">VS</div>
          <div class="team">{{ event.teamB }}</div>
        </div>
        <div class="event-description" v-else>
          <p>{{ event.description }}</p>
        </div>
      </div>
    </div>
    <div class="event-footer">
      <router-link
        :to="
          $route.params.id
            ? `/${profileId}/club/${$route.params.id}/event/${event.id}`
            : `/${profileId}/club/event/${event.id}`
        "
      >
        <div class="view-details">
          View Details
          <a-icon type="double-right" />
        </div>
      </router-link>
      <div class="button-wrap" v-if="!viewOnly">
        <span>
          <a-button
            type="primary"
            icon="file-add"
            class="save-button"
            @click="changeForm(event)"
            >Edit</a-button
          >
        </span>
        <span>
          <a-popconfirm
            title="Sure you want to delete this video?"
            @confirm="deleteEvent(event._id)"
            ok-text="Yes"
            cancel-text="No"
          >
            <a-button type="danger" icon="delete">Delete</a-button>
          </a-popconfirm>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
const eventsRepository = RepositoryFactory.get("events");
import { Base } from "@/models";

export default {
  name: "EventCard",
  props: ["event", "eventId", "viewOnly"],
  data() {
    return {};
  },
  computed: {
    profileId() {
      return Base.profileId();
    },
    localClubId() {
      return localStorage["club-id"];
    }
  },
  methods: {
    getDate(date) {
      let d = new Date(date);
      return `${moment()
        .month(d.getUTCMonth())
        .format("MMM")} ${d.getUTCDate()}`;
    },
    getTime(time) {
      if (time) {
        let hour = time.split(":")[0];
        let min = time.split(":")[1];
        let hours = hour % 12 || 12;
        let AmOrPm = hour >= 12 ? "PM" : "AM";
        return `${hours}:${min} ${AmOrPm}`;
      }
      return "";
    },
    changeForm(val) {
      this.$emit("onChange", val);
    },
    deleteEvent(eventId) {
      eventsRepository
        .deleteClubEvents(eventId)
        .then(response => {
          this.$message.success("Event Deleted Successfully!");
          this.$emit("onDelete", eventId);
        })
        .catch(error => {
          this.$message.error("Error while deleting Event!");
        });
    }
  }
};
</script>
